import SignIn from '~/components/shared/Auth/SignIn';

function SignInPage() {
  return <SignIn />;
}

export default SignInPage;

SignInPage.isPublic = true;
